module.exports = __webpack_public_path__ + "img/ylmf-content.ddfadab2.png";